import { useApiInspectionsV1LoadsRetrieve } from 'api';
import { useSearchParams } from 'react-router-dom';

export const useSearchedLoad = () => {
  const [searchParams] = useSearchParams();

  const loadIdParam = searchParams.get('loadId');
  const loadId = loadIdParam ? Number(loadIdParam) : undefined;

  return useApiInspectionsV1LoadsRetrieve(loadId || 0, {
    query: {
      enabled: Boolean(loadId),
    },
  });
};
